import { MatPaginatorIntl } from '@angular/material';
import { Injectable } from '@angular/core';

import { I18n } from '@ngx-translate/i18n-polyfill';

@Injectable()
export class PaginatorIntl extends MatPaginatorIntl {
  constructor(private i18n: I18n) {
    super();
    this.getAndInitTranslations();
  }

  getAndInitTranslations() {
    this.itemsPerPageLabel = this.i18n({value: 'Items per page:', id: 'ItemsPerPage'});
    this.nextPageLabel = this.i18n({value: 'Next page', id: 'NextPage'});
    this.previousPageLabel = this.i18n({value: 'Previous Page', id: 'PreviousPage'});
    this.getRangeLabel = this.rangeLabel;
  }

  rangeLabel = (page: number, pageSize: number, length: number) =>  {
    if (length === 0 || pageSize === 0) {
      return `0 / ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} / ${length}`;
  }
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/utils/paginator-intl.ts